import React, { useState } from 'react';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import { useAuth } from '../AuthContext';
import { API_LOGIN } from '../Config/ApiUrlConstant';
import './LoginForm.css';

const SECRET_KEY = process.env.REACT_APP_AUTH_ENCRYPTION_KEY_SCHOOL || 'local-dev-rslm-key';

const ModuleGlyph = ({ type, label }) => <div className={`login-glyph login-glyph-${type}`}><span>{type === 'book' ? 'AB' : type === 'chart' ? '++' : 'o'}</span><small>{label}</small></div>;

export default function LoginForm() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setIsSubmitting(true);
    try {
      const response = await axios.post(API_LOGIN, {
        username: CryptoJS.AES.encrypt(username, SECRET_KEY).toString(),
        password: CryptoJS.AES.encrypt(password, SECRET_KEY).toString(),
      });
      if (response.data.token) login(response.data.token, response.data.role, response.data.must_change_password);
      else setError(response.data.message || 'Unable to sign in.');
    } catch (requestError) {
      setError(requestError.response?.data?.message || 'Unable to sign in. Please check your details.');
    } finally { setIsSubmitting(false); }
  };

  return <div className="school-login-layout">
    <section className="school-login-story">
      <div className="login-story-brand"><span>RS</span><div><strong>RSLM School</strong><small>Administration portal</small></div></div>
      <div className="login-story-copy"><p>Connected school operations</p><h1>Every school day, <em>in focus.</em></h1><span>Manage learners, fee records, reports, and the daily financial picture from one secure workspace.</span></div>
      <div className="login-illustration" aria-hidden="true"><div className="login-sun" /><div className="login-hill login-hill-back" /><div className="login-hill login-hill-front" /><div className="login-schoolhouse"><i /><b /><strong /><span /></div><div className="login-path" /><ModuleGlyph type="book" label="students" /><ModuleGlyph type="chart" label="reports" /><ModuleGlyph type="coin" label="fees" /></div>
      <p className="login-story-footnote">A calmer way to run school administration.</p>
    </section>
    <section className="school-login-panel"><div className="login-panel-inner"><p className="login-panel-kicker">Secure sign in</p><h2>Welcome back.</h2><p className="login-panel-help">Use your school administration account to continue.</p>{error ? <div className="login-error" role="alert">{error}</div> : null}
      <form onSubmit={handleSubmit} className="school-login-form"><label htmlFor="school-username">Username<input id="school-username" type="text" value={username} onChange={(event) => setUsername(event.target.value)} autoComplete="username" placeholder="Enter your username" required /></label><label htmlFor="school-password">Password<input id="school-password" type="password" value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="current-password" placeholder="Enter your password" required /></label><button type="submit" disabled={isSubmitting}>{isSubmitting ? 'Signing in...' : 'Sign in to portal'} <span>-&gt;</span></button></form><p className="login-security-note"><i />Your session is protected by action-level permissions.</p></div></section>
  </div>;
}
